export const energySalePages = {
  startWithPackage: [
    {
      page: 'otpFormPage',
      step: 1,
      displayPackageBanner: true,
      displayBigBanner: true,
    },
    {
      page: 'otpVerifyCodePage',
      step: 1,
      displayPackageBanner: true,
    },
    {
      page: 'loadingPage',
      step: 1,
    },
    {
      page: 'serviceMessagePage',
      step: 1,
      displayPackageBanner: true,
    },
    {
      page: 'personalInfoPage',
      step: 2,
      displayPackageBanner: true,
    },
    {
      page: 'digitalSignaturePage',
      step: 2,
      displayPackageBanner: true,
    },
    {
      page: 'paymentPage',
      step: 2,
      displayPackageBanner: true,
    },
    {
      page: 'successPage',
      step: 3,
    },
    {
      page: 'errorPage',
      step: 3,
      displayPackageBanner: false
    },
  ],
  startWithoutPackage: [
    {
      page: 'otpFormPage',
      step: 0,
    },
    {
      page: 'otpVerifyCodePage',
      step: 0,
    },
    {
      page: 'loadingPage',
      step: 0,
    },
    {
      page: 'serviceMessagePage',
      step: 0,
    },
    {
      page: 'packagesPage',
      step: 1,
    },
    {
      page: 'personalInfoPage',
      step: 2,
      displayPackageBanner: true,
    },
    {
      page: 'digitalSignaturePage',
      step: 2,
      displayPackageBanner: true,
    },
    {
      page: 'paymentPage',
      step: 2,
      displayPackageBanner: true,
    },
    {
      page: 'successPage',
      step: 3,
    },
    {
      page: 'errorPage',
      step: 3,
      displayPackageBanner: false
    },
  ],
};
